import { countConversationsResolved } from './countConversationsResolved'
import { oneReply } from './filters'

export const countConversationsResolvedWithSingleReply = {
  ...countConversationsResolved,
  filters: [oneReply],
  key: 'countConversationsResolvedWithSingleReply',
}
